var $c688fc1a398cdc12$exports = {};
$c688fc1a398cdc12$exports = {
    "clear": `T\xf6rl\xe9s`,
    "invalid": `(\xe9rv\xe9nytelen)`,
    "loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "noResults": `Nincsenek tal\xe1latok`
};


export {$c688fc1a398cdc12$exports as default};
//# sourceMappingURL=hu-HU.module.js.map
